import {FC, memo} from 'react'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {SECTOR_OPTIONS} from '../../../constants'
import Pagination from '../component/Pagination'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {setBrowseContractFilter, soSelector} from '../../../redux/slices/soSlices'
import Skeleton from 'react-loading-skeleton'
import i18next from 'i18next'

interface TableBrowseSIPProps {
  contractList: any[]
  loading: boolean
  tooltip: string
  paginateNumber: any
  numberURL: string[]
  onSelectedContract: (item: any) => void
  onRowExpand: (e: any) => void
}

// eslint-disable-next-line react/display-name
export const TableBrowseSIP = memo((props: TableBrowseSIPProps) => {
  const {contractList, tooltip, loading, paginateNumber, numberURL, onSelectedContract, onRowExpand} = props
  const {t} = useTranslation()
  const {browseContractFilter: filter} = useAppSelector(soSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setBrowseContractFilter({...filter, ...value}))
  }

  return (
    <div className='table-responsive bdr'>
      <table className='table'>
        <thead>
          <tr className='d-flex jusify-content-center w-100 align-items-center'>
            <th className='td-order-1 text-center'></th>
            <th className='td-order-3 text-center'>{t('kontrak-nomor')} SAP</th>
            <th className='td-order-3 text-center'>{t('order-pembeli')}</th>
            <th className='td-order-3 text-center'>{t('Sektor')}</th>
          </tr>
        </thead>
      </table>
      <table className='table'>
        <tr className='d-flex jusify-content-center w-100 align-items-center'>
          <td className='td-order-1 text-center'>
            <div className='text-transparent' style={{padding: '.42rem 0'}}>
              -
            </div>
          </td>
          <td className='td-order-3 text-center pm-0'>
            <TextInputV2
              placeholder={t('kontrak-nomor') + ' SAP'}
              value={filter?.sap_number ?? ''}
              onChange={({target}) => handleFilterChange({sap_number: target.value})}
            />
          </td>
          <td className='td-order-3 text-center pm-0'>
            <TextInputV2
              placeholder={t('order-pembeli')}
              value={filter?.customer_name ?? ''}
              onChange={({target}) => handleFilterChange({customer_name: target.value})}
            />
          </td>
          <td className='td-order-3 text-center pm-0'>
            <Selection
              formSelectProps={{style: {padding: 0, border: 0}}}
              placeholder={t('Sektor')}
              data={SECTOR_OPTIONS}
              value={filter?.sector_id ?? ''}
              onChange={(value: any) => handleFilterChange({sector_id: value})}
            />
          </td>
        </tr>
        {loading && [1,2,3,4].map((item) => {
          return <tr key={item} className='d-flex jusify-content-center w-100 align-items-center'>
            <td className='td-order-1 p-0 text-center'>
              <Skeleton width={'80%'} height={30}/>
            </td>
            <td className='td-order-3 text-center'>
            <Skeleton width={'80%'} height={30}/>
            </td>
            <td className='td-order-3 text-center'>
            <Skeleton width={'80%'} height={30}/>
            </td>
            <td className='td-order-3 text-center'>
            <Skeleton width={'80%'} height={30}/>
            </td>
          </tr>
        })}
      </table>
      {contractList?.map((item: any, index: any) => {
        return (
          <>
            <table className={index % 2 === 0 ? 'table bg-secondary' : 'table'}>
              <tbody>
                <tr className='d-flex jusify-content-center w-100 align-items-center'>
                  <td className='text-center td-order-1 check'>
                    <Form.Check
                      reverse
                      type='checkbox'
                      id={item?.customer_code}
                      onChange={() => onSelectedContract(item)}
                    />
                  </td>
                  <td
                    className='td-order-3 text-center d-flex align-items-center justify-content-center'
                    style={{padding: '.95rem 0'}}
                  >
                    <button
                      className='iconArow d-flex justify-content-center align-items-center me-2'
                      data-target={'target' + item.sap_number}
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t(tooltip)}
                      onClick={onRowExpand}
                    ></button>
                    {item.sap_number}
                  </td>
                  <td className='td-order-3 text-center'>
                    <span className='d-block' style={{padding: '.08rem 0'}}>
                      {item.customer?.title == null
                        ? item.customer?.name
                        : item.customer?.title + '-' + item.customer?.name}
                    </span>
                  </td>
                  <td className='td-order-3 text-center'>
                    <span className='d-block' style={{padding: '.08rem 0'}}>
                      {t(item.sector?.name)}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className='d-flex justify-content-center lefttt'>
              <div className='table-responsive sub-table'>
                <table className='table'>
                  <tr className='fold' id={'target' + item.sap_number}>
                    <td className='fold-wrapperContent'>
                      <div className='fold-content' style={{padding: '0'}}>
                        <table className='table-border table-fix bg-primary'>
                          <thead>
                            <tr className='d-flex-justify-content-center align-items-center'>
                              <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                              <th className='td-order-1 text-center'>
                                {t('kontrak-produk')} {t('kode')}
                              </th>
                              <th className='td-order-2 text-center'>{t('sub-order-produk')}</th>
                              <th className='td-order-2 text-center'>{t('sub-order-kuantum')}</th>
                            </tr>
                          </thead>
                        </table>
                        <table>
                          <tbody>
                            {item?.order_sub_details?.map((item: any, index: number) => {
                              return (
                                <tr
                                  key={item?.product_name ?? index}
                                  className='d-flex-justify-content-center align-items-center'
                                >
                                  <td className='td-order-2 text-center'>
                                    {item?.product_type_desc}
                                  </td>
                                  <td className='td-order-1 text-center'>
                                    {item?.material_number.slice(-7)}
                                  </td>
                                  <td className='td-order-2 text-center'>{item?.product_name}</td>
                                  <td className='td-order-2 text-center'>
                                  {
                                    (parseFloat(item?.quantum_contract || 0).toLocaleString(
                                      i18next.language,
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                    ))
                                    + (item?.sector_id == 3 ? ' MT' : ' Ton')
                                    }
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </>
        )
      })}
      <div className='my-5'>
        <Pagination paginate={paginateNumber} test={numberURL} />
      </div>
    </div>
  )
})
